import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import api from '../api';

// Cart page — /cart/:bizId  OR  /cart  (shows all carts)
// Checkout flow inline

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Syne:wght@700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
.sf-root{min-height:100vh;background:#080b14;color:#e2e8f0;font-family:'DM Sans',sans-serif;}
.sf-body{max-width:600px;margin:0 auto;padding:20px 16px 120px;}
.sf-back{display:inline-flex;align-items:center;gap:6px;color:#6366f1;font-size:13px;text-decoration:none;font-weight:600;margin-bottom:20px;}
.sf-title{font-family:'Syne',sans-serif;font-size:24px;font-weight:800;color:#e2e8f0;margin-bottom:20px;}
/* Cart items */
.sf-item{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:14px;padding:14px;margin-bottom:10px;display:flex;gap:12px;align-items:center;}
.sf-item-img{width:56px;height:56px;border-radius:10px;object-fit:cover;background:#1a2540;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0;}
.sf-item-name{font-size:14px;font-weight:600;color:#e2e8f0;margin-bottom:2px;}
.sf-item-price{font-size:13px;color:#6366f1;font-weight:700;}
.sf-item-variant{font-size:11px;color:#64748b;margin-top:2px;}
.sf-qty{display:flex;align-items:center;gap:8px;margin-left:auto;}
.sf-qty-btn{width:28px;height:28px;border-radius:8px;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.05);color:#e2e8f0;font-size:15px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .15s;}
.sf-qty-btn:hover{background:rgba(255,255,255,.1);}
.sf-qty-num{font-size:14px;font-weight:700;color:#e2e8f0;min-width:22px;text-align:center;}
/* Summary */
.sf-summary{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);border-radius:16px;padding:18px;margin-bottom:20px;}
.sf-sum-row{display:flex;justify-content:space-between;font-size:13px;color:#94a3b8;padding:5px 0;}
.sf-sum-total{display:flex;justify-content:space-between;font-size:16px;font-weight:700;color:#e2e8f0;padding:12px 0 0;border-top:1px solid rgba(255,255,255,.07);margin-top:6px;}
/* Checkout form */
.sf-section-title{font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:1.5px;margin:18px 0 10px;}
.sf-field{margin-bottom:12px;}
.sf-label{display:block;font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:5px;}
.sf-input{width:100%;padding:10px 13px;background:rgba(255,255,255,.05);border:1px solid rgba(99,102,241,.2);border-radius:9px;color:#e2e8f0;font-family:'DM Sans',sans-serif;font-size:13px;outline:none;transition:border .2s;}
.sf-input:focus{border-color:#6366f1;}
.sf-select{width:100%;padding:10px 13px;background:rgba(13,20,40,.9);border:1px solid rgba(99,102,241,.2);border-radius:9px;color:#e2e8f0;font-family:'DM Sans',sans-serif;font-size:13px;outline:none;cursor:pointer;}
/* Payment */
.sf-pay-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
.sf-pay-opt{padding:12px;border-radius:10px;border:1px solid rgba(255,255,255,.08);background:rgba(255,255,255,.03);text-align:center;cursor:pointer;transition:all .18s;}
.sf-pay-opt.active{border-color:#6366f1;background:rgba(99,102,241,.1);}
.sf-pay-opt-icon{font-size:22px;margin-bottom:4px;}
.sf-pay-opt-label{font-size:12px;font-weight:600;color:#94a3b8;}
.sf-pay-opt.active .sf-pay-opt-label{color:#6366f1;}
/* Buttons */
.sf-btn{width:100%;padding:14px;border-radius:12px;border:none;font-family:'DM Sans',sans-serif;font-size:15px;font-weight:700;cursor:pointer;transition:all .18s;display:flex;align-items:center;justify-content:center;gap:7px;}
.sf-btn-primary{background:linear-gradient(135deg,#6366f1,#8b5cf6);color:#fff;box-shadow:0 4px 20px rgba(99,102,241,.3);}
.sf-btn-primary:hover:not(:disabled){transform:translateY(-1px);}
.sf-btn-primary:disabled{opacity:.6;cursor:not-allowed;}
/* Success */
.sf-success{text-align:center;padding:40px 20px;}
.sf-success-ico{font-size:64px;margin-bottom:16px;}
.sf-success-title{font-family:'Syne',sans-serif;font-size:24px;font-weight:800;color:#e2e8f0;margin-bottom:8px;}
.sf-success-sub{font-size:14px;color:#64748b;line-height:1.6;}
/* Bottom bar */
.sf-bar{position:fixed;bottom:0;left:0;right:0;background:rgba(8,11,20,.97);border-top:1px solid rgba(255,255,255,.07);padding:12px 16px;padding-bottom:max(12px,env(safe-area-inset-bottom));z-index:50;}
.sf-empty{text-align:center;padding:60px 20px;color:#334155;}
.sf-empty-ico{font-size:48px;margin-bottom:14px;}
@keyframes spin{to{transform:rotate(360deg)}}
.sf-spinner{width:28px;height:28px;border:3px solid rgba(99,102,241,.15);border-top-color:#6366f1;border-radius:50%;animation:spin .7s linear infinite;margin:40px auto;}
`;

function fmtPrice(p, cur='NPR') { return `${cur} ${((p||0)/100).toFixed(2)}`; }

export default function Storefront() {
  const { bizId }    = useParams();
  const navigate     = useNavigate();
  const [cart,       setCart]       = useState(null);
  const [step,       setStep]       = useState('cart'); // cart → checkout → success
  const [loading,    setLoading]    = useState(true);
  const [placing,    setPlacing]    = useState(false);
  const [order,      setOrder]      = useState(null);
  const [form,       setForm]       = useState({ deliveryType:'pickup', note:'', paymentMethod:'cash' });

  const loadCart = useCallback(async () => {
    if (!bizId) return;
    try {
      const { data } = await api.get(`/storefront/cart/${bizId}`);
      setCart(data);
    } catch {}
    setLoading(false);
  }, [bizId]);

  useEffect(() => { loadCart(); }, [loadCart]);

  const updateQty = async (productId, variantId, delta) => {
    try {
      const { data } = await api.post(`/storefront/cart/${bizId}`, { productId, variantId, qty: delta });
      setCart(data);
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
  };

  const placeOrder = async () => {
    setPlacing(true);
    try {
      const { data } = await api.post(`/storefront/orders/${bizId}`, form);
      setOrder(data);
      setCart(null);
      setStep('success');
    } catch (e) { alert(e.response?.data?.error || 'Failed to place order'); }
    setPlacing(false);
  };

  const items = cart?.items || [];
  const subtotal = items.reduce((s, i) => s + (i.price * i.qty), 0);
  const currency = items[0]?.currency || 'NPR';

  if (loading) return <div className="sf-root"><style>{CSS}</style><div className="sf-spinner"/></div>;

  return (
    <div className="sf-root">
      <style>{CSS}</style>
      <div className="sf-body">
        <Link to={bizId ? `/b/${bizId}` : '/dashboard'} className="sf-back">← Back</Link>

        {step === 'success' && order ? (
          <div className="sf-success">
            <div className="sf-success-ico">🎉</div>
            <div className="sf-success-title">Order Placed!</div>
            <div style={{fontSize:13,color:'#6366f1',fontWeight:700,marginBottom:8}}>#{order.orderNumber}</div>
            <p className="sf-success-sub">Your order has been sent to the business.<br/>You'll be notified when it's ready.</p>
            <div style={{marginTop:20,fontSize:15,fontWeight:700,color:'#e2e8f0'}}>{fmtPrice(order.total, order.currency)}</div>
            {order.pointsEarned > 0 && <div style={{fontSize:12,color:'#fbbf24',marginTop:6}}>+{order.pointsEarned} loyalty points earned! ⭐</div>}
            <button onClick={()=>navigate('/dashboard')} className="sf-btn sf-btn-primary" style={{marginTop:24}}>Back to Dashboard</button>
          </div>

        ) : step === 'checkout' ? (
          <>
            <div className="sf-title">Checkout</div>

            <div className="sf-section-title">Delivery</div>
            <div className="sf-pay-grid" style={{marginBottom:14}}>
              {[['pickup','🏪','Pickup'],['dine-in','🪑','Dine In'],['delivery','🛵','Delivery']].map(([val,ic,lb])=>(
                <div key={val} className={`sf-pay-opt${form.deliveryType===val?' active':''}`}
                  onClick={()=>setForm(f=>({...f,deliveryType:val}))}>
                  <div className="sf-pay-opt-icon">{ic}</div>
                  <div className="sf-pay-opt-label">{lb}</div>
                </div>
              ))}
            </div>

            {form.deliveryType==='delivery' && (
              <div className="sf-field">
                <label className="sf-label">Delivery Address</label>
                <input className="sf-input" value={form.deliveryAddress||''} onChange={e=>setForm(f=>({...f,deliveryAddress:e.target.value}))} placeholder="Street, city…"/>
              </div>
            )}

            <div className="sf-field">
              <label className="sf-label">Note to business (optional)</label>
              <input className="sf-input" value={form.note} onChange={e=>setForm(f=>({...f,note:e.target.value}))} placeholder="Special requests…"/>
            </div>

            <div className="sf-section-title">Payment</div>
            <div className="sf-pay-grid">
              {[['cash','💵','Cash'],['esewa','💳','eSewa'],['khalti','💜','Khalti'],['card','💳','Card']].map(([val,ic,lb])=>(
                <div key={val} className={`sf-pay-opt${form.paymentMethod===val?' active':''}`}
                  onClick={()=>setForm(f=>({...f,paymentMethod:val}))}>
                  <div className="sf-pay-opt-icon">{ic}</div>
                  <div className="sf-pay-opt-label">{lb}</div>
                </div>
              ))}
            </div>

            <div className="sf-summary" style={{marginTop:20}}>
              <div className="sf-sum-total"><span>Total</span><span>{fmtPrice(subtotal, currency)}</span></div>
            </div>
          </>

        ) : (
          <>
            <div className="sf-title">Your Cart</div>
            {items.length === 0 ? (
              <div className="sf-empty">
                <div className="sf-empty-ico">🛒</div>
                <div style={{fontSize:16,fontWeight:700,color:'#e2e8f0',marginBottom:6}}>Cart is empty</div>
                <div style={{fontSize:13}}>Browse products and add items to your cart</div>
                {bizId && <button onClick={()=>navigate(`/b/${bizId}`)} className="sf-btn sf-btn-primary" style={{marginTop:20,width:'auto',padding:'10px 24px'}}>Browse Products</button>}
              </div>
            ) : (
              <>
                {items.map((item, i) => (
                  <div key={i} className="sf-item">
                    <div className="sf-item-img">
                      {item.imageUrl ? <img src={item.imageUrl} alt={item.productName} style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:10}}/> : '📦'}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div className="sf-item-name">{item.productName}</div>
                      {item.variantName && <div className="sf-item-variant">{item.variantName}</div>}
                      <div className="sf-item-price">{fmtPrice(item.price * item.qty, currency)}</div>
                    </div>
                    <div className="sf-qty">
                      <button className="sf-qty-btn" onClick={()=>updateQty(item.productId, item.variantId, -1)}>−</button>
                      <span className="sf-qty-num">{item.qty}</span>
                      <button className="sf-qty-btn" onClick={()=>updateQty(item.productId, item.variantId, 1)}>+</button>
                    </div>
                  </div>
                ))}
                <div className="sf-summary">
                  <div className="sf-sum-row"><span>Subtotal</span><span>{fmtPrice(subtotal, currency)}</span></div>
                  <div className="sf-sum-row"><span>Delivery</span><span>Calculated at checkout</span></div>
                  <div className="sf-sum-total"><span>Total</span><span>{fmtPrice(subtotal, currency)}</span></div>
                </div>
              </>
            )}
          </>
        )}

        <div style={{height:80}}/>
      </div>

      {/* Action bar */}
      {items.length > 0 && step !== 'success' && (
        <div className="sf-bar">
          {step === 'checkout' ? (
            <button className="sf-btn sf-btn-primary" onClick={placeOrder} disabled={placing}>
              {placing ? '⏳ Placing Order…' : `✅ Place Order · ${fmtPrice(subtotal, currency)}`}
            </button>
          ) : (
            <button className="sf-btn sf-btn-primary" onClick={()=>setStep('checkout')}>
              Checkout · {fmtPrice(subtotal, currency)}
            </button>
          )}
        </div>
      )}
    </div>
  );
}